module.exports = __webpack_public_path__ + "img/home_four_004.e63a20fa.png";